export default __webpack_public_path__ + "static/3-a557f3dd70453f5293a5ca96e9258991.png";